import React from 'react';
import { Star } from 'lucide-react';
import GOOGLE_REVIEWS from '../../../data/googleReviews';
import './ReviewsMarquee.css';

// Two opposing auto-scrolling rows form a "reviews wall". Each row duplicates
// its own card set so the CSS translateX(-50%) loop is seamless.
const half = Math.ceil(GOOGLE_REVIEWS.length / 2);
const ROW_TOP = GOOGLE_REVIEWS.slice(0, half);
const ROW_BOTTOM = GOOGLE_REVIEWS.slice(half);

function ReviewCard({ review }) {
  return (
    <div className="review-card">
      <div className="review-card-stars" aria-label="5 out of 5 stars">
        {[0, 1, 2, 3, 4].map((i) => (
          <Star key={i} size={15} className="review-star" />
        ))}
      </div>
      <p className="review-card-quote">{review.quote}</p>
      <div className="review-card-meta">
        <div className="review-card-author">{review.author}</div>
        <div className="review-card-role">{review.role}</div>
      </div>
    </div>
  );
}

function ReviewRow({ reviews, direction }) {
  // Duplicate the set for a continuous loop.
  const cards = [...reviews, ...reviews];
  return (
    <div className="reviews-marquee">
      <div className={`reviews-track reviews-track-${direction}`}>
        {cards.map((review, idx) => (
          <ReviewCard key={`${review.author}-${idx}`} review={review} />
        ))}
      </div>
    </div>
  );
}

function ReviewsMarquee() {
  return (
    <section className="reviews-section">
      <div className="container">
        <h2 className="section-title">
          What our <span className="home-gold-text">clients</span> are saying
        </h2>
        <p className="section-subtitle">Real reviews from real local business owners.</p>
      </div>

      <div className="reviews-rows">
        <ReviewRow reviews={ROW_TOP} direction="left" />
        <ReviewRow reviews={ROW_BOTTOM} direction="right" />
      </div>
    </section>
  );
}

export default ReviewsMarquee;
